const getData = [
    {
        "Title": "Textured Excellence",
        "Desc": "Our range of products, including Interior and Exterior Emulsion Paints, are specially designed to endure changing weather conditions while offering vibrant, long-lasting colors. This project is a testament to the craftsmanship and attention to detail that Shital Paints brings to every assignment, ensuring customer satisfaction and aesthetic appeal.",
        "imageURL":"Project2.jpg" 
    },
    {
        "Title": "Perfect Shade Selection",
        "Desc": "At Shital Paints, every brushstroke reflects our dedication to creating beautiful, enduring spaces. This color sampling project is a perfect example of how we empower our clients by turning vision into reality.",
        "imageURL":"Project1.jpg"   
    },
    {
        "Title": "Shital Paints: From Vision to Reality",
        "Desc": "With nearly two decades of experience, we are a trusted manufacturer, wholesaler, and trader of premium paints and coatings. Based in Ahmedabad, Gujarat, we operate from a state-of-the-art infrastructure that drives our company’s growth. From interior emulsion to exterior solutions, every product we offer is crafted with care and delivered with precision.",
        "imageURL":"Project3.jpg"
    },
]

export {getData}